module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 6),
      expression: "step === 6"
    }],
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-card"
  }), _vm._v(" "), _c('h2', [_vm._v("Płatność online (Zamówienie nr " + _vm._s(_vm.orderData.orderNumber) + ")")])]), _vm._v(" "), (_vm.step === 6) ? _c('div', {
    staticClass: "order-summary-table"
  }, [_c('div', {
    staticClass: "desktop-order-summary"
  }, [_c('div', {
    staticClass: "dos-name-section",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('h3', [_vm._v("Nadawca")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.orderData.customer.FirstName) + "\n                    " + _vm._s(_vm.orderData.customer.LastName) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.orderData.address.Street) + "\n                    " + _vm._s(_vm.orderData.address.StreetNo) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.orderData.address.PostalCode) + "\n                    " + _vm._s(_vm.orderData.address.City) + "\n                ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "dos-address-section"
  }, [_c('h3', [_vm._v("Kwota do zapłaty")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("toFixed")(_vm.orderData.delivery.cost)))])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 6) ? _c('div', {
    staticClass: "order-summary-table"
  }, [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ost-entry"
  }, [_c('p', {
    staticClass: "ost-number"
  }, [_vm._v("1.")]), _vm._v(" "), _c('p', {
    staticClass: "ost-name"
  }, [(_vm.orderData.delivery.withCarry == 1) ? _c('em', [_vm._v("Dostawa z wniesieniem\n                    " + _vm._s(_vm.orderData.order.extOrderId))]) : _vm._e(), _vm._v(" "), (_vm.orderData.delivery.withCarry == 0) ? _c('em', [_vm._v("Dostawa " + _vm._s(_vm.orderData.order.extOrderId))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "ost-price"
  }, [_vm._v("\n                " + _vm._s(_vm._f("toFixed")(_vm.orderData.delivery.cost)) + " zł\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "ost-summary"
  }, [_c('p', {
    staticClass: "ost-number"
  }, [_vm._v(" ")]), _vm._v(" "), _c('p', {
    staticClass: "ost-name"
  }, [_vm._v("SUMA")]), _vm._v(" "), _c('p', {
    staticClass: "ost-price"
  }, [_vm._v("\n                " + _vm._s(_vm._f("toFixed")(_vm.orderData.delivery.cost)) + " zł\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e(), _vm._v(" "), (_vm.step === 6 && _vm.orderType != '') ? _c('div', [_vm._v("\n        URL dla klienta:\n        "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkToPay),
      expression: "linkToPay"
    }],
    staticStyle: {
      "border": "1px solid #ddd",
      "font-size": "20px",
      "width": "600px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.linkToPay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkToPay = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step === 6 && _vm.orderType == '') ? _c('div', {
    staticClass: "ui one column grid container"
  }, [_c('div', {
    staticClass: "column",
    attrs: {
      "id": "payments-option-list"
    }
  }, _vm._l((_vm.methodsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "payu-method"
    }, [_c('img', {
      staticClass: "pay-method-logo",
      staticStyle: {
        "display": "block !important",
        "margin": "5px auto 12px auto"
      },
      attrs: {
        "src": item.brandImageUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.orderData.order.payMethod),
        expression: "orderData.order.payMethod"
      }],
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "type": "radio",
        "name": "payMethod"
      },
      domProps: {
        "value": item.value,
        "checked": _vm._q(_vm.orderData.order.payMethod, item.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.orderData.order, "payMethod", item.value)
        }
      }
    }), _vm._v("\n                " + _vm._s(item.name) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('payu-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "order": _vm.orderData.order
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 6),
      expression: "step === 6"
    }],
    staticClass: "order-info-block acceptance-block mb-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.acceptPayuRules),
      expression: "orderData.acceptPayuRules"
    }],
    attrs: {
      "type": "checkbox",
      "id": "payu-acceptance",
      "name": "payu-check"
    },
    domProps: {
      "checked": Array.isArray(_vm.orderData.acceptPayuRules) ? _vm._i(_vm.orderData.acceptPayuRules, null) > -1 : (_vm.orderData.acceptPayuRules)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.orderData.acceptPayuRules,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.orderData, "acceptPayuRules", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.orderData, "acceptPayuRules", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.orderData, "acceptPayuRules", $$c)
        }
      }
    }
  }), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "payu-info"
  }, [_vm._v("\n            Zlecenie realizacji płatności: Zlecenie wykonuje PayU SA; Dane\n            odbiorcy, tytuł oraz kwota płatności dostarczane są PayU SA\n            przez odbiorcę; Zlecenie jest przekazywane do realizacji po\n            otrzymaniu przez PayU SA Państwa wpłaty. Płatność udostępniana\n            jest odbiorcy w ciągu 1 godziny, nie później niż do końca\n            następnego dnia roboczego; PayU SA nie pobiera opłaty od\n            realizacji usługi.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "payu-info payu-last"
  }, [_vm._v("\n            Administratorem Twoich danych osobowych w rozumieniu ustawy z\n            dnia 29 sierpnia 1997 r. o ochronie danych osobowych (tj. Dz.U.\n            z 2002 roku, nr 101, poz. 926 z późn. zm.) jest PayU SA z\n            siedzibą w Poznaniu (60-166), przy ul. Grunwaldzkiej 182. Twoje\n            dane osobowe będą przetwarzane zgodnie z obowiązującymi\n            przepisami prawa, w celu świadczenia usług i archiwizacji. Twoje\n            dane nie będą udostępniane innym podmiotom, z wyjątkiem\n            podmiotów upoważnionych na podstawie przepisów prawa.\n            Przysługuje Tobie prawo dostępu do treści swoich danych oraz ich\n            poprawiania. Podanie danych jest dobrowolne, ale niezbędne do\n            realizacji ww. celu.\n        ")])]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 5),
      expression: "step == 5"
    }],
    staticClass: "contactForm pb-20",
    attrs: {
      "target": "_top",
      "custom-validation-reporting": "show-all-on-submit"
    }
  }, [_c('fieldset', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.customer.FirstName),
      expression: "orderData.customer.FirstName"
    }],
    staticClass: "contactField",
    class: {
      'error-field':
      _vm.customerFieldsError.FirstName == true,
    },
    attrs: {
      "type": "text",
      "name": "Name",
      "onfocus": "(this.value == 'Imię') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Imię')",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.customer.FirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.customer, "FirstName", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.customer.LastName),
      expression: "orderData.customer.LastName"
    }],
    staticClass: "contactField",
    class: {
      'error-field': _vm.customerFieldsError.LastName == true,
    },
    attrs: {
      "type": "text",
      "name": "Name",
      "onfocus": "(this.value == 'Nazwisko') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Nazwisko')",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.customer.LastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.customer, "LastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.customer.Email),
      expression: "orderData.customer.Email"
    }],
    staticClass: "contactField",
    class: {
      'error-field': _vm.customerFieldsError.Email == true,
    },
    attrs: {
      "type": "text",
      "name": "Name",
      "onfocus": "(this.value == 'E-mail') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'E-mail')",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.customer.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.customer, "Email", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.customer.MobilePhone),
      expression: "orderData.customer.MobilePhone"
    }],
    staticClass: "contactField",
    class: {
      'error-field':
      _vm.customerFieldsError.MobilePhone == true,
    },
    attrs: {
      "type": "text",
      "name": "Name",
      "onfocus": "(this.value == 'Nr telefonu komórkowego') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Nr telefonu komórkowego')",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.customer.MobilePhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.customer, "MobilePhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-info-block acceptance-block no-email-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noEmail),
      expression: "noEmail"
    }],
    staticClass: "noEmail",
    attrs: {
      "type": "checkbox",
      "name": "noEmail",
      "id": "noEmail"
    },
    domProps: {
      "checked": Array.isArray(_vm.noEmail) ? _vm._i(_vm.noEmail, null) > -1 : (_vm.noEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.noEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.noEmail = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.noEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.noEmail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "noEmail",
    attrs: {
      "for": "noEmail"
    }
  }, [_vm._v("Nie posiadam adresu e-mail i rezygnuję z powiadomień\n                    dotyczących realizacji zlecenia")])])]), _vm._v(" "), _c('fieldset', [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.remarks),
      expression: "orderData.remarks"
    }],
    staticClass: "order-form-comments",
    attrs: {
      "rows": "10",
      "cols": "30"
    },
    domProps: {
      "value": (_vm.orderData.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData, "remarks", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customerDataError),
      expression: "customerDataError"
    }],
    staticClass: "error-message"
  }, [_vm._v("\n                Prosimy o wypełnienie wszystkich pól.\n            ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.customerDataError &&
        _vm.orderData.customer.MobilePhone != ''
      ),
      expression: "\n                    customerDataError &&\n                    orderData.customer.MobilePhone != ''\n                "
    }],
    staticClass: "error-message"
  }, [_vm._v("\n                Prosimy o wpisanie właściwego numeru telefonu w formacie 9\n                cyfr nie rozdzielonych spacjami.\n            ")])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('a', {
    staticClass: "float-left button bg-blue full-bottom order-change-data-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.showInfBox()
      }
    }
  }, [_vm._v("Zmień dane do faktury")]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInvoicePart),
      expression: "showInvoicePart"
    }]
  }, [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.CompanyName),
      expression: "orderData.invoice.CompanyName"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Name",
      "placeholder": "Nazwa firmy lub podmiotu",
      "id": "Company",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.CompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "CompanyName", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.NIP),
      expression: "orderData.invoice.NIP"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Name",
      "placeholder": "NIP",
      "id": "NIP",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.NIP)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "NIP", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.FirstName),
      expression: "orderData.invoice.FirstName"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Name",
      "placeholder": "Imię",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.FirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.LastName),
      expression: "orderData.invoice.LastName"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Name",
      "placeholder": "Nazwisko",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.LastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "LastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.Street),
      expression: "orderData.invoice.Street"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Name",
      "placeholder": "Ulica",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.Street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "Street", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.StreetNo),
      expression: "orderData.invoice.StreetNo"
    }],
    staticClass: "contactField order-field-name",
    attrs: {
      "type": "text",
      "name": "Nr-budynku",
      "placeholder": "Nr budynku",
      "id": "Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.StreetNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "StreetNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.ApartmentNo),
      expression: "orderData.invoice.ApartmentNo"
    }],
    staticClass: "contactField order-field-name",
    attrs: {
      "type": "text",
      "name": "Nr-lokalu",
      "placeholder": "Nr lokalu",
      "id": "Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.ApartmentNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "ApartmentNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.City),
      expression: "orderData.invoice.City"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Miejscowosc",
      "placeholder": "Miejscowość",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "City", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.PostalCode),
      expression: "orderData.invoice.PostalCode"
    }],
    staticClass: "contactField order-field-name",
    attrs: {
      "type": "text",
      "name": "Kod-pocztowy",
      "maxlength": "6",
      "placeholder": "Kod pocztowy",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.PostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "PostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customerDataError && _vm.showInvoicePart),
      expression: "customerDataError && showInvoicePart"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n                Prosimy o wypełnienie wszystkich niezbędnych pól.\n            ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dos-name-section",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('h3', [_vm._v("Odbiorca")]), _vm._v(" "), _c('p', [_vm._v("DTS Transport Sp. z o.o.")]), _vm._v(" "), _c('p', [_vm._v("ul. Wał Miedzeszyński 251,")]), _vm._v(" "), _c('p', [_vm._v("04-866 Warszawa")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dos-address-section"
  }, [_c('h3', [_vm._v("Forma płatności")]), _vm._v(" "), _c('p', [_vm._v("Przelew online")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ost-header"
  }, [_c('p', {
    staticClass: "ost-number"
  }, [_vm._v("Lp.")]), _vm._v(" "), _c('p', {
    staticClass: "ost-name"
  }, [_vm._v("Nazwa usługi")]), _vm._v(" "), _c('p', {
    staticClass: "ost-price"
  }, [_vm._v("Kwota")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "payu-check"
    }
  }, [_vm._v("Akceptuję\n            "), _c('a', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "href": "http://static.payu.com/sites/terms/files/payu_terms_of_service_single_transaction_pl_pl.pdf"
    }
  }, [_vm._v("\"Regulamin pojedynczej transakcji płatniczej PayU\"")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-person"
  }), _vm._v(" "), _c('h2', [_vm._v("Dane odbiorcy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Podając dane osobowe potwierdzam prawidłowość adresu\n                    dostawy, kwot zamówień z Salonu Agata Meble, a także\n                    pozostałych danych wprowadzonych w procesie rejestracji\n                    zamówienia dostawy. Deklaruję tym samym chęć\n                    skorzystania z oferty usługi transportowej zawartej w\n                    formularzu.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Wprowadzone dane osobowe wykorzystywane są jedynie w\n                    procesie rejestracji zamówienia, jego realizacji,\n                    kontroli jakości, a także notyfikowania użytkownika\n                    drogą mailową i smsową o jego przebiegu.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Wprowadzone dane nie są udostępniane osobom trzecim, ani\n                    podmiotom zewnętrznym.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }, [_c('i', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-android-alert"
  }), _vm._v(" "), _c('h2', [_vm._v("Uwagi do zamówienia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Jeśli masz uwagi, które chciałbyś przekazać zespołowi\n                    realizacyjnemu, wpisz je w poniższym polu.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                Jeżeli chcesz otrzymać fakturę VAT, prosimy o skorzystanie z\n                poniżej opcji, a następnie wypełnienie niezbędnych pól.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-document-text"
  }), _vm._v(" "), _c('h2', [_vm._v("Faktura VAT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Wprowadzone dane wykorzystywane są jedynie w celach\n                    wystawienia Faktury VAT i nie są udostępniane osobom\n                    trzecim, ani podmiotom zewnętrznym.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Domyślnie załadowane zostają dane wprowadzone dotychczas\n                    w procesie rejestracji zamówienia dostawy. Prosimy o ich\n                    sprawdzenie i ewentualną zmianę.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_c('b', [_vm._v("UWAGA:")]), _vm._v(" zmiana danych do faktury nie skutkuje\n                    zmianą wprowadzonych danych osobowych i adresu\n                    realizacji.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }, [_c('i', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }, [_c('i', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }, [_c('i', {})])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9709750","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderSummary.vue
// module id = 266
// module chunks = 1